import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuardService } from '../../services/auth-guard.service';
import { AuthService } from '../../../api/services/auth.service';
import { PreferencesService } from '../../../api/services/preferences.service';
import { UserService } from '../../../api/services/user.service';

@Component({
  selector: 'app-rename-modal',
  templateUrl: './rename-modal.component.html',
  styleUrls: ['./rename-modal.component.scss']
})
export class RenameModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
              private authService: AuthService,
              private preferencesService: PreferencesService,
              private userService: UserService
    ) { }

  @Input() customName: string;
  @Input() defaultName: string;
  @Input() key: string;
  orgId: string;

  restoreDefault() {
    this.preferencesService.setPreference('CUSTOMER', this.orgId, this.key, {Value: ''}).subscribe(() => {
      this.activeModal.close();
    });
  }

  confirmChange() {
    this.preferencesService.setPreference('CUSTOMER', this.orgId, this.key, {Value: this.customName}).subscribe(() => {
      this.activeModal.close();
    });
  }

  ngOnInit() {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      this.orgId = user['Organization ID'];
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/renamable/rename-modal/rename-modal.component.ts